import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { availableTagNumbersTypes } from 'actions/types'

const initialState = {}
const baseType = availableTagNumbersTypes.FETCH_MANAGEMENT_NUMBERS

const reducer = combineReducers({
  requestState: requestStateReducer(baseType),
  data: dataReducer({ initialState, baseType }),
})

export default reducer
